import $ from 'jquery';
import peekaboo from 'peekaboo-toggle';
import domready from 'domready';
domready(function () {
  $('.product-hero > div:not(#ensemble_related_products).block > .block-title').peekaboo({
    namespace: 'pdp-accordions',
    callback: function callback(obj) {
      var $content = $(obj.event.currentTarget).parent().next();
      if ($content.css('display') == 'block') {
        $content.animate({
          height: 'toggle'
        }, 150); // closing should be snappy. Interaction is expected
      } else {
        $content.animate({
          height: 'toggle'
        });
      }
    }
  });

  // The following accordions should be expanded by default on page load
  $('.block.related .block-title button, .block.upsell .block-title button, .block.available-upgrades .block-title button').click();
});